import { useEffect } from "react";
import Overlay from "components/ui/loading-spinners/Overlay/Overlay";
import usePerformRouting from "features/PerformRouting";

export default function AuthRouting() {
  const { isSuccess, performRouting } = usePerformRouting();

  useEffect(() => {
    if (isSuccess) {
      performRouting();
    }
  }, [isSuccess]);

  return <Overlay />;
}
